import type { TreeNodeType } from '@/shared/lib/tree'
import type { ChangeEvent } from 'react'

import React, { useState } from 'react'
import { orderBy } from 'lodash/fp'
import { SearchIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
	InputGroup,
	InputGroupAddon,
	InputGroupInput,
} from '../../ui/input-group'
import {
	TreeFilter,
	TreeFilterGroup,
	TreeFilterList,
} from '../../ui/tree-filter'

type TreeSelectProps = {
	placeholder?: string
	tree: TreeNodeType[]
	value: string[]
	onChange(values: string[]): void
}

const TreeSelect = ({
	placeholder,
	tree,
	value: selected = [],
	onChange: setSelected,
}: TreeSelectProps) => {
	const { t } = useTranslation()
	const [searchText, setSearchText] = useState<string>('')
	const handleInputChange = (event: ChangeEvent<HTMLInputElement>) =>
		setSearchText(event.target.value)

	const notFoundText =
		placeholder ||
		t('general_no_results_found', {
			defaultValue: 'No results found',
		})

	return (
		<TreeFilter
			className='max-h-[min(calc(var(--radix-popper-available-height)-3rem),400px)]'
			checked={selected}
			setChecked={setSelected}
		>
			<InputGroup className='max-w-full'>
				<InputGroupInput
					value={searchText}
					onChange={handleInputChange}
					placeholder={t('app.search', { defaultValue: 'Search' })}
				/>
				<InputGroupAddon>
					<SearchIcon className='size-4' />
				</InputGroupAddon>
			</InputGroup>
			<TreeFilterGroup>
				<TreeFilterList
					notFoundText={notFoundText}
					search={searchText}
					items={orderBy(['children.length'], ['asc'], tree)}
				/>
			</TreeFilterGroup>
		</TreeFilter>
	)
}
export default TreeSelect
